import '../dashboard.css';
import { Link } from 'react-router-dom';

const Sidebar = () => (
  <div className="sidebar">
    <h2 style = {{color: 'white', fontWeight: 'bold'}}>Admin Panel</h2>
    <nav>
      <Link to="/admin_dashboard">Dashboard</Link>
      <Link to="/news_management">News Management</Link>
      <Link to="/support_request">Support Request</Link>
    </nav>
  </div>
);

export default Sidebar;
